import { useState, useEffect } from "react";

export default function BlurInput({ value, onCommit, style }) {
  const [localValue, setLocalValue] = useState(value);

  // Keep synced if the external value changes
  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleBlur = () => {
    if (localValue !== value) {
      onCommit(localValue); // only commit if changed
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") e.target.blur(); // commit immediately
    if (e.key === "Escape") setLocalValue(value); // revert
  };

  return (
    <input
      style={style}
      type="text"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      //className="border rounded px-2 py-1 w-full"
    />
  );
}

